export default "__VITE_ASSET__cxPsEcbi__"